import i18n from 'config/i18n';
import dayjs, { Dayjs } from 'dayjs';
import minMax from 'dayjs/plugin/minMax';
import * as yup from 'yup';

import { getLocale } from 'utils/date';

dayjs.extend(minMax);

const editRouteSchema = () => {
  const t = i18n.getFixedT(getLocale(), 'common');

  return yup.object({
    startTime: yup
      .mixed<Dayjs>()
      .test(
        'dayjs-valid',
        () => t('invalidTime'),
        (v) => (v ? v.isValid() : false)
      )
      .required(),
    startDate: yup
      .mixed<Dayjs>()
      .test(
        'dayjs-valid',
        () => t('invalidDate'),
        (v) => (v ? v.isValid() : false)
      )
      .required(),
    editAppointmentType: yup.string().when(['isRecurring'], {
      is: (isRecurring: boolean) => isRecurring,
      then: yup
        .string()
        .required(
          t('validationFieldRequired', { name: t('editAppointmentType') })
        )
    }),
    isRecurring: yup.boolean().optional()
  });
};

export default editRouteSchema;
